// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__koq7k","span":"Toggle_span__WHiqb","checkbox":"Toggle_checkbox__zySds"};